import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=bb81e432&"
import script from "./ButtonBar.vue?vue&type=script&lang=ts&"
export * from "./ButtonBar.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=bb81e432&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports